import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
let LabModel = class LabModel {
    constructor() {
        this._labAnchorMap = proxy(null);
    }
    updateLabAnchorMap(labAnchorMap) {
        this._labAnchorMap.value = labAnchorMap;
    }
    getAnchorItem(labName) {
        return this._labAnchorMap.value[labName];
    }
    subscribeLabAnchorMap(callback) {
        subscribe(() => this._labAnchorMap.value, (newValue) => {
            callback(newValue);
        });
    }
};
LabModel = __decorate([
    injectable()
], LabModel);
export { LabModel };
